module.exports = __webpack_public_path__ + "img/sand-dune-decal-23.8ad887b0.png";